export const TermsOfService = "TERMS_OF_SERVICE"
export const PrivacyPolicy = "PRIVACY_POLICY"
export const AboutApp = "ABOUT_APP"